import { useCallback, useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ReportsTypeCategorySelector from 'components/selectors/ReportsTypeCategorySelector';
import OrganizationsSelector from 'components/selectors/OrganizationsSelector';
import { selectListDefaultOptions } from 'store/lists/selectors';
import _get from 'lodash/get';

const TopFilters = ({ topFilters, setTopFilters }) => {
  const reportTypesList = useSelector(state => selectListDefaultOptions(state, 'report-types'));

  const organizationId = useMemo(
    () =>
      _get(
        topFilters.find(f => f.name === 'can_see'),
        'value'
      ),
    [topFilters]
  );

  const category = useMemo(
    () =>
      _get(
        topFilters.find(f => f.name === 'category'),
        'value'
      ),
    [topFilters]
  );

  const updateTopFilters = useCallback(
    (key, value, operation) => {
      setTopFilters(
        topFilters.map(f => {
          return f.name === key ? { ...f, value, operation: operation || f.operation } : f;
        })
      );
    },
    [topFilters, setTopFilters]
  );

  return (
    <Row className="d-flex align-items-center w-100p">
      <Col xs={2}>
        <OrganizationsSelector
          onChange={data => updateTopFilters('can_see', data?.value, 'oneOf')}
          filter={{ value: organizationId }}
          placeholder="Select company(ies)"
          isMulti
          autoFocus={false}
          className="mb-0"
        />
      </Col>
      <Col xs={2}>
        <ReportsTypeCategorySelector
          onChange={(_, type) =>
            updateTopFilters('category', type?.category ? type.category : null, '=')
          }
          value={reportTypesList.find(t => t.category === category) || []}
          placeholder="Select type"
          isClearable={true}
          autoFocus={false}
          className="mb-0"
        />
      </Col>
    </Row>
  );
};

TopFilters.propTypes = {
  topFilters: PropTypes.shape({
    name: PropTypes.string,
    operation: PropTypes.string,
    value: PropTypes.oneOf([PropTypes.string, PropTypes.number])
  }).isRequired,
  setTopFilters: PropTypes.func.isRequired
};

export default TopFilters;
